module.exports = __webpack_public_path__ + "img/scurve-min.c2d9be6d.png";